<template>
	<Modal
		:open="isOpen"
		:title="title"
		@close="isOpen = false"
	>
		<template #body>
			<MobileTimePickerControl
				v-if="isOpen"
				:value="{ minutes, seconds }"
				:max-minutes="maxMinutes"
				@input="onTimeUpdate"
			/>
		</template>
		<template #footer-buttons>
			<button
				class="button button--primary"
				@click="onSave"
			>
				{{ labels.save }}
			</button>
		</template>
	</Modal>
</template>

<script>
import Modal from '@components/modal/Modal';
import { bus, EVENT } from '@videotools/js/events';
import MobileTimePickerControl from '@components/MobileTimeInput/MobileTimePickerControl';

const events = [EVENT.TIME_PICKER_MODAL_OPEN];

export default {
	name:       'TimePickerModalMobile',
	components: { MobileTimePickerControl, Modal },
	data() {
		return {
			title:              '',
			minutes:            0,
			seconds:            0,
			maxMinutes:         120,
			isOpen:             false,
			timeUpdateCallback: null,
		};
	},
	computed: {
		labels() {
			return {
				save: this.transUcfirst('commons.type_save', { type: this.trans('commons.time') }),
			};
		},
	},
	created() {
		for (const event of events) {
			bus.subscribe(event, this[`BUS-${event}`]);
		}
	},
	destroyed() {
		for (const event of events) {
			bus.unsubscribe(event, this[`BUS-${event}`]);
		}
	},
	methods: {
		[`BUS-${EVENT.TIME_PICKER_MODAL_OPEN}`](
			{
				minutes = 0,
				seconds = 0,
				title = '',
				maxMinutes = 120,
				onChange = (_minutes, _seconds) => {},
			}
		) {
			this.title = title;
			this.minutes = minutes;
			this.seconds = seconds;
			this.timeUpdateCallback = onChange;
			this.isOpen = true;
			this.maxMinutes = maxMinutes;
		},
		[`BUS-${EVENT.TIME_PICKER_MODAL_CLOSE}`]() {
			this.isOpen = false;
		},
		onTimeUpdate({ minutes, seconds }) {
			this.minutes = minutes;
			this.seconds = seconds;
		},
		onSave() {
			if (this.timeUpdateCallback) {
				this.timeUpdateCallback(this.minutes, this.seconds);
			}
			this.isOpen = false;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

::v-deep {
	.modal--content {
		background: var(--color-grey-900);
	}

	.mobile {
		.modal--body {
			padding: 32px 16px 8px 16px;
		}
	}
}
</style>
